import { AnimatePresence } from "motion/react";
import { createContext, useContext, useEffect, useMemo, useState } from "react";
import * as motion from "motion/react-client";
import useScreenDimensions from "../hooks/useScreenDimensions";
import { useCannotCreateNewCampaignModal } from "../hooks/useCannotCreatNewCampaignModal";
import { StandardButton } from "./standardButton";
import { useAuth } from "@clerk/clerk-react";
import { datasource } from "../datasource/datasource";
import useOrganziations from "../hooks/useOrganizations";

export const CannotCreateNewCampaignModal = () => {
  const isOpen = useCannotCreateNewCampaignModal(state => state.isOpen);
  const setIsOpen = useCannotCreateNewCampaignModal(state => state.setIsOpen);
  const type = useCannotCreateNewCampaignModal(state=>state.type);
  const { width, height } = useScreenDimensions();
  const {getToken} = useAuth();
  const org = useOrganziations(state=>state.activeOrganization);
  const [updateSubUrl, setUpdateSubUrl] = useState<string>('');

  const cancelEvent = (e: React.MouseEvent) => e.stopPropagation();

  const closeModal = () => {
    setIsOpen(false);
  }

  useEffect(() => {
      const runThis = async () => {
        if (org?.planTypeId === 4) {
          return;
        }
        if (org?.id) {
          const token = await getToken();
          const session = await datasource.getStripeUpdatePaymentSession(org.id, token as string);
          setUpdateSubUrl(session.updateSub);
        }
      };
      runThis();
    }, [org]);

  const firstLine = useMemo(() => {
    if (type === 'newCampaign') {
      return 'You must be on the Unlimited Plan to create more than three campaigns'
    } else {
      return 'You must be on the Unlimited Plan to create shareable links'
    }
  }, [type]);

  const secondLine = useMemo(() => {
    if (type === 'newCampaign') {
      return 'The Unlimited Plan also give you access to Unlimited Video Interviews, Multiple Users, and so much more'
    } else {
      return 'The Unlimited Plan also give you access to Unlimited Video Interviews, Unlimited Campaigns, Multiple Users, and so much more'
    }
  }, [type]);

  return (

    <AnimatePresence>
      {isOpen ? (
        <motion.div
          key={"campaignModal"}
          style={{
            width,
            height,
            backgroundColor: "rgba(0, 0, 0, .3)",
            position: "fixed",
            zIndex: 999990,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            top: 0,
            left: 0,
          }}
          onClick={closeModal}
          animate={{ opacity: 1 }}
          initial={{ opacity: 0 }}
          exit={{ opacity: 0 }}
        >
          <div
            onClick={cancelEvent}
            style={{
              width: "40rem",
              minWidth: 400,
              backgroundColor: "white",
              padding: 24,
              borderRadius: 16,
              opacity: 1,
            }}
          >
            <div style={{fontWeight: 500, fontSize: '1.2rem', marginBottom: '1rem'}}>
              Hold on there
            </div>
            <div style={{marginBottom: '.5rem'}}>
              {firstLine}
            </div>
            <div style={{marginBottom: '1rem'}}>
              {secondLine}
            </div>
            <StandardButton buttonText="Change Subscription" onClick={() => window.open(updateSubUrl)} />
          </div>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
};
